import { render } from "./MyFooter.vue?vue&type=template&id=a8cb857c"
const script = {}

import exportComponent from "/var/www/rentasdhelos.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__